import { Dashboard } from "@mui/icons-material"

const MODULES = {
    USER_MODULE: 1,//UI PURPOSE
    // PRODUCT_MODULE:2,
    // REGION_MODULE:3,
    CAMPS:4,
    BENEFICIARY_MODULE:5,
    BENEFICIARY_FETCH:6,
    BENEFICIARY_ADD:7,
    DASHBOARD: 8
}
//last count 28
export default MODULES
/*
//user wise access

ADMIN: *
IMPACT_ANALYSIS_TEAM:
    DASHBOARD
    BENIFIICIARY_MODULE
    BENIFIICIARY_DONATIONS
    BENIFICIARY_LOGS
    EVENT_MODULE

REGISTRATION_TEAM
    BENIFIICIARY_MODULE
    BENIFICIARY_ADD
    USER_MODULE
    BRC:12,
    TEACHER
    GOVEREMENT
    REGIONS
    CAMP

TESTING_TEAM
    BENIFIICIARY_MODULE
    BENIFICIARY_TEST

VALIDATION_TEAM
    BENIFIICIARY_MODULE
    BENIFICIARY_UPDATE
    BENIFICIARY_VALIDATE
    BRC:12,
    TEACHER
    GOVEREMENT
    REGIONS
    CAMP

EVENT_TEAM
    EVENT_MODULE
    EVENT_BENIFICIARY_ASSIGN
    EVENT_CREATE_UPDATE
    USER_MODULE
    NGOS
    DONORS

SIT_MANAGER
    FOLLOWUP_LIST
    EVENT_MODULE
    ASSIGN_FOLLOWUP

SIT_TEAM
    FOLLOWUP_LIST
    UPDATE_FOLLOWUP

GOVERMENT
    DASHBOARD
    BENIFIICIARY_MODULE
    BENIFIICIARY_DONATIONS

DONOR
    BENIFIICIARY_MODULE
    BENIFIICIARY_DONATIONS

NGO
    BENIFIICIARY_MODULE
    BENIFIICIARY_DONATIONS

TEACHER
    BENIFIICIARY_MODULE
    BENIFIICIARY_DONATIONS

BRC:12,

    BENIFIICIARY_MODULE
    BENIFIICIARY_DONATIONS
*/